<template>
  <el-table
    class="itf-table payments"
    :cell-class-name="cellClass"
    :data="value"
    style="width: 100%"
    :stripe="true"
    empty-text="No Data"
  >
    <el-table-column prop="amount" label="Amount" width="80">
      <template slot-scope="scope">
        <router-link :to="'/me/finance/payment/' + scope.row.id">{{scope.row.amount}}</router-link>
      </template>
    </el-table-column>
    <el-table-column prop="currency" label="" width="50" class="currency">
    </el-table-column>
    <el-table-column prop="status" label="" width="100">
      <template slot-scope="scope">
        <span :class="statusClass(scope.row.status)">{{ scope.row.status | status }}</span>
      </template>
    </el-table-column>
    <el-table-column prop="causeName" label="Cause" width="280">
    </el-table-column>
    <el-table-column prop="email" label="Donor" width="280">
    </el-table-column>
    <el-table-column prop="dtc" label="Date" width="180">
    </el-table-column>
  </el-table>
</template>
<script>
import PaymentStatus from '@/pages/Finance/PaymentStatus.js'

export default {
  props: {
    value: Array
  },
  setup() {
    function cellClass(v) {
      if (v.columnIndex == 0) {
        return 'amount'
      }
      else if (v.columnIndex == 1) {
        return 'currency'
      }
      else if (v.columnIndex == 2) {
        return 'status'
      }
      return null
    }

    // setup return
    return {
      'statusClass': PaymentStatus.statusClass,
      cellClass
    }
  },
  filters: {
    status: function (value) {
      const map = {
        ok: 'succeeded',
        fail: 'failed',
        more: 'incomplete',
        pending: 'incomplete'
      }
      if (value in map) {
        return map[value]
      }
      return value
    }
  }
}
</script>
<style lang="scss">
  .el-table.payments {
    td.currency {
      text-transform: uppercase;
      color: #aaa;
    }
    td.amount {
      text-align: right;
    }
    td.status {
      text-align: center;
      span.badge {
        min-width: 67px;
      }
    }
  }
</style>
